import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";
import { useWorkspaceContext } from "../state/workspaceContext";
import {
    addAdditionalEmail,
    getAdditionalEmailsForUser,
    removeAdditionalEmail,
} from "../lib/user";
import { queryClient } from "../queryClient";
import { AddAdditionalEmailDto } from "../common/dto/user/add-additional-email.dto";

const QUERY_KEY = ["receipt-emails"];

export function useReceiptEmails() {
    const { activeWorkspace } = useWorkspaceContext();

    return useQuery({
        queryKey: QUERY_KEY,
        queryFn: async () => {
            const email = await getAdditionalEmailsForUser();
            return email.emails;
        },
        enabled: !!activeWorkspace?.id,
        placeholderData: keepPreviousData,
    });
}

export function useRemoveReceiptEmail() {
    return useMutation({
        mutationFn: async (email: string) => {
            await removeAdditionalEmail(email);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: QUERY_KEY,
            });
        },
    });
}

export function useAddReceiptEmail() {
    return useMutation({
        mutationFn: async (data: AddAdditionalEmailDto) =>
            await addAdditionalEmail(data),
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: QUERY_KEY,
            });
        },
    });
}
